var parseQueryErrors = function () {
    var errors = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        errors[_i] = arguments[_i];
    }
    var errorMessages = errors.filter(function (e) { return e !== undefined; });
    return errorMessages.toString();
};
export default parseQueryErrors;
